module.exports = __webpack_public_path__ + "img/ccxs.8b4f91fb.svg";